var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.isEdit ? _vm.$t("编辑账户") : _vm.$t("新增账户"),
        "close-on-click-modal": false,
        width: "640px"
      },
      on: { close: _vm.handleClose },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "div",
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("取消")))
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm }
                    },
                    [_vm._v(_vm._s(_vm.$t("确定")))]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "account-container"
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                "show-message": false,
                model: _vm.formData,
                rules: _vm.formRule,
                "label-position": "top",
                size: "mini"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("账号"),
                            prop: "userAccountName"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("请输入账号") },
                            model: {
                              value: _vm.formData.userAccountName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "userAccountName", $$v)
                              },
                              expression: "formData.userAccountName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("密码"), prop: "userPwd" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: _vm.$t("请输入密码") },
                                model: {
                                  value: _vm.formData.userPwd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "userPwd", $$v)
                                  },
                                  expression: "formData.userPwd"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("姓名"), prop: "userName" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("请输入姓名") },
                            model: {
                              value: _vm.formData.userName,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "userName", $$v)
                              },
                              expression: "formData.userName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("电话") } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("请输入电话") },
                            model: {
                              value: _vm.formData.mobile,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "mobile", $$v)
                              },
                              expression: "formData.mobile"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("邮箱") } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("请输入邮箱") },
                            model: {
                              value: _vm.formData.email,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "email", $$v)
                              },
                              expression: "formData.email"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("酒店"), prop: "hotelVids" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "hotel-select",
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                placeholder: _vm.$t("请选择酒店")
                              },
                              on: { change: _vm.handleHotelChange },
                              model: {
                                value: _vm.formData.hotelVids,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "hotelVids", $$v)
                                },
                                expression: "formData.hotelVids"
                              }
                            },
                            _vm._l(_vm.hotelOptions, function(item) {
                              return _c("el-option", {
                                key: item.hotelVid,
                                attrs: {
                                  label: item.hotelName,
                                  value: item.hotelVid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("状态") } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.formData.state,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "state", $$v)
                              },
                              expression: "formData.state"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "is-required",
                          attrs: { label: _vm.$t("角色"), prop: "role" }
                        },
                        [
                          _c("OrgRole", {
                            ref: "OrgRoleRef",
                            model: {
                              value: _vm.formData.role,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "role", $$v)
                              },
                              expression: "formData.role"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }